module.exports = __webpack_public_path__ + "img/availabill.c6649dd1.svg";